<template>
  <div
    class="relative flex flex-col w-full bg-white rounded-lg p-6 border border-gray-300 shadow min-h-[140px] items-stretch my-4"
  >
    <!-- Top Row: Image and Title/Subtitle/Button -->
    <div class="flex flex-row gap-6 w-full items-start">
      <div
        class="flex flex-col items-center w-24 h-24 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0 -ml-6 -mt-6"
      >
        <img
          :src="previewImg"
          alt="Landing Page Preview"
          class="object-cover w-full h-full rounded-lg"
        />
        <span class="text-xs text-gray-500 mt-1 text-center font-medium"
          >Landing Page</span
        >
      </div>
      <div class="flex flex-col flex-1 min-w-0 justify-center pl-2">
        <div class="flex flex-row items-start justify-between w-full">
          <div class="flex flex-col min-w-0">
            <span class="font-semibold text-xl text-gray-900 leading-7 mb-1">{{
              title
            }}</span>
            <span class="text-base text-gray-600 leading-6 mb-2">{{
              subtitle
            }}</span>
          </div>
          <div class="flex flex-row items-center gap-2">
            <button
              class="flex items-center gap-2 bg-gray-100 text-primary-purple px-4 py-2 rounded-md text-sm font-semibold hover:bg-primary-purple hover:text-white transition"
              @click="openPreviewPage"
            >
              <span>Edit page</span>
            </button>
            <button
              class="flex items-center gap-2 bg-gray-100 text-primary-purple px-4 py-2 rounded-md text-sm font-semibold hover:bg-primary-purple hover:text-white transition"
              @click="openPreviewPage"
            >
              <span>Preview Page</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- About Section -->
    <div class="flex flex-col gap-2 mt-6">
      <span class="font-semibold text-base mb-1 text-gray-900"
        >About the Program</span
      >
      <p class="text-sm text-gray-700 whitespace-pre-line leading-6">
        {{ about }}
      </p>
      <button
        class="flex items-center gap-2 w-fit mt-2 bg-gray-100 text-primary-purple px-3 py-1.5 rounded text-sm font-medium hover:bg-primary-purple hover:text-white transition"
        @click="copyToClipboard"
      >
        <span
          v-html="NOTE_ICON"
          class="w-5 h-5 self-center relative top-[1px]"
        ></span>
        <span class="align-middle">{{ isCopied ? "Copied!" : "Copy" }}</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
// import BaseButton from "@/components/shared/BaseButton.vue";
import { NOTE_ICON } from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "LandingPagePreviewSection",
  // components: { BaseButton },
  props: {
    previewImg: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    about: { type: String, required: true },
    programUuid: { type: String, required: true },
  },
  setup(props) {
    const isCopied = ref(false);
    const copyToClipboard = () => {
      navigator.clipboard.writeText(props.about);
      isCopied.value = true;
      setTimeout(() => {
        isCopied.value = false;
      }, 2000);
    };
    const openPreviewPage = () => {
      const landingUrl = `${process.env.VUE_APP_EXPERT_APP_BASE_URL}/expert-program-overview?invite=true&program=${props.programUuid}`;
      window.open(landingUrl, "_blank");
    };
    return {
      isCopied,
      copyToClipboard,
      NOTE_ICON,
      openPreviewPage,
    };
  },
});
</script>
